/** @type {import("@mui/material").ThemeOptions} */
const baseThemeOptions = {
  components: {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "36px",
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          ":last-child": {
            paddingBottom: "16px",
          },
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          overflowX: "auto",
        },
      },
    },
  },
};

// https://github.com/binwiederhier/ntfy-android/blob/main/app/src/main/res/values/colors.xml

export const lightTheme = {
  ...baseThemeOptions,
  components: {
    ...baseThemeOptions.components,
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          // Fond vert forêt pour les notifications, cohérent avec l'identité
          backgroundColor: "#007A5E",
          // Texte blanc pour un contraste maximal
          color: "#FFFFFF",
          // Ombre subtile pour détacher la notification du fond
          boxShadow: "0 4px 12px rgba(0, 122, 94, 0.25)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: "8px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          // Ombre douce pour les cartes, évite l'effet "plat"
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
          border: "1px solid rgba(0, 122, 94, 0.1)",
        },
      },
    },
  },
  palette: {
    mode: "light",
    background: {
      // Fond principal : blanc cassé avec une infime teinte verte (harmonie globale)
      default: "#F8FAF9",
      // Fond des cartes/panneaux : blanc pur pour un contraste net
      paper: "#FFFFFF",
    },
    primary: {
      // Vert Forêt officiel du Cameroun - parfait pour le mode clair
      main: "#007A5E",
      light: "#33A085",
      dark: "#005A45",
      contrastText: "#FFFFFF",
    },
    secondary: {
      // Jaune Or soutenu - assez foncé pour rester lisible sur fond blanc
      main: "#D4A017",
      light: "#F4C430",
      dark: "#A67C00",
      contrastText: "#1A1A1A",
    },
    error: {
      // Rouge Cameroun - vif mais pas agressif
      main: "#CE1126",
      light: "#E84D60",
      dark: "#9E0D1D",
    },
    warning: {
      // Ocre / Terre de Sienne - chaleureux et distinctif
      main: "#CC7722",
    },
    success: {
      // Vert Palmier - pour les validations
      main: "#2E8B57",
    },
    info: {
      // Bleu profond - pour les informations neutres
      main: "#1976D2",
    },
    text: {
      // Texte principal : gris très foncé (presque noir) pour une lisibilité maximale
      primary: "#1A1F1D",
      // Texte secondaire : gris moyen avec légère teinte verte
      secondary: "#5A6360",
      disabled: "#9EA7A4",
    },
    divider: "rgba(0, 122, 94, 0.12)",
  },
};

/** @type {import("@mui/material").ThemeOptions} */
export const darkTheme = {
  ...baseThemeOptions,
  components: {
    ...baseThemeOptions.components,
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          color: "#000",
          backgroundColor: "#aeaeae",
        },
      },
    },
  },
  palette: {
    mode: "dark",
    background: {
      paper: "#1b2124",
    },
    primary: {
      main: "#65b5a3",
    },
    secondary: {
      main: "#6cead0",
    },
    error: {
      main: "#fe4d2e",
    },
  },
};
